import { environment } from 'src/environments/environment';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { HttpService } from 'src/app/core/services/api/http.service';
import { ProgressBarUpdatesService } from 'src/app/core/services/progress-bar-updates.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DEFAULT_MAX_FILE_SIZE } from '../../consts/default-max-file-size.const';

@Component({
    selector: 'app-import-production-file',
    templateUrl: './import-production-file.component.html',
    styleUrls: ['./import-production-file.component.css']
})
export class ImportProductionFileComponent implements OnInit {
    showImport: boolean = environment.showImportFeature;
    uploadForm!: FormGroup;
    fileInput: any;
    isUploaded: boolean = false;
    loadingSubmit: boolean = false;
    formDataPayLoad: any = new FormData();
    fileSize: any = DEFAULT_MAX_FILE_SIZE;
    photoAllowedExt: any = ['.csv'];
    @ViewChild('attachedFile') attachedFileEle!: ElementRef;
    showConfirmPopup: boolean = false;
    @ViewChild('messageComponent', { static: false }) messageComponent: any;

    fileName: any;
    progressBarPopup: boolean = false;
    progressBarInfo: any;

    constructor(
        private _api: HttpService,
        private notificationService: NotificationsService,
        private errHandle: ErrorHandlingService,
        private router: Router,
        private route: ActivatedRoute,
        private _ProgressService: ProgressBarUpdatesService,
        private location: Location
    ) { }

    ngOnInit(): void {
        this.uploadForm = new FormGroup({
            records: new FormControl('', []),
        });

        this._ProgressService.getUpdatedProgressBarObservable().subscribe((data: any) => {
            if (data?.module === 'production') {
                setTimeout(() => {
                    this.progressBarPopup = data?.is_finished ? false : true;
                }, 2000);
                this.progressBarInfo = data;
            }
        });

        const savedProgressBarInfo = JSON.parse(localStorage.getItem('progressBarInfo')!) || null;

        if (savedProgressBarInfo?.module === 'production') {
            this.progressBarInfo = savedProgressBarInfo || null;
        }

        if (this.progressBarInfo) {
            this.progressBarPopup = true;
            if (this.progressBarInfo?.module !== 'production') {
                this.messageComponent?.open();
            }
        }
    }

    fetchFile() {
        this.attachedFileEle.nativeElement.click();
    }

    deleteFile() {
        this.isUploaded = false;
        this.fileName = '';
        this.uploadForm.controls['records'].reset();
    }

    uploadImage(event: any) {
        const file = event.target.files[0];
        if (file) {
            if (this.uploadForm.controls['records'].valid) {
                this.formDataPayLoad?.delete('file');
                this.isUploaded = true;
                const reader = new FileReader();
                this.formDataPayLoad.append('file', file);
                reader.readAsDataURL(file);
                reader.onload = (e: any) => {
                    this.fileName = file?.name;
                };
            } else {
                this.isUploaded = false;
                this.uploadForm.controls['records'].markAsTouched();
            }
        }
    }

    save() {
        if (this.uploadForm.invalid || !this.uploadForm.dirty) {
            this.uploadForm.markAllAsTouched();
            return;
        }
        this.loadingSubmit = true;
        const fileControl = this.uploadForm.get('records');
        if (fileControl && this.attachedFileEle && this.attachedFileEle.nativeElement.files.length > 0) {
            this.formDataPayLoad = new FormData();
            this.formDataPayLoad.append('file', this.attachedFileEle.nativeElement.files[0]);
        }
        this._api.postReq('/contracts/import-contracts-report-43-new-template', this.formDataPayLoad).subscribe(
            (res) => {
                this.loadingSubmit = false;
                this.isUploaded = false;
                this.notificationService.success('', res?.message);
                let progressInfo: any = {
                    id: res?.data?.batchId,
                    value: 0,
                    is_finished: false,
                    module: 'production'
                };
                localStorage.setItem('progressBarInfo', JSON.stringify(progressInfo));
                this._ProgressService.invokeUpdatedProgressBar(progressInfo);
                this._ProgressService.setIntervalTimeFun();
            },
            (err) => {
                this.errHandle.errorHandling(err);
                this.loadingSubmit = false;
            }
        );
    }

    rejected() {
        this.messageComponent.close();
        this.router.navigate(['/dashboard/import/production']);
    }

    accepted() {
        this.cancelBatch();
    }

    back() {
        this.location.back();
    }

    cancelBatch() {
        this.loadingSubmit = true;
        this._api.deleteReq(`/batch/${this.progressBarInfo?.id}`).subscribe(
            (res) => {
                this.loadingSubmit = false;
                this.notificationService.success('', res?.message);
                this._ProgressService.removeSetIntervalTime();
                this.progressBarInfo = '';
                this.progressBarPopup = false;
                this.messageComponent.close();
            },
            (err) => {
                this.errHandle.errorHandling(err);
                this.loadingSubmit = false;
            }
        );
    }
} 